import { css } from 'emotion'

// Note: the structure of this is very likely to change

export default (props = {}) => {
   const {
      h2TextColor = '#000',
      linkTextColor = '#444'
   } = props

   return css`
      float: left;
      display: block;
      position: relative;
      width: 100%;
      font-size: 1em;

      a {
         color: ${linkTextColor};
         border-bottom: 1px solid #ccc;
      }

      strong, b {
         font-weight: 700 !important;
         color: #333;
      }

      p {
         margin: 0;
         padding: 0;
         overflow-wrap: break-word;
         word-wrap: break-word;
      }

      h1 {
         font-weight: 500;
         font-size: 1.6em;
         line-height: 1.1em;
         color: #000;
         margin: 0px 0px 12px 0px;
         padding: 0px;
      }

      h2 {
         font-weight: 500;
         font-size: 1.4em;
         line-height: 1.5em;
         margin: 0px 0px 12px 0px;
         padding: 0px;
         color: ${h2TextColor};
      }

      h2 strong {
         font-weight: 500 !important;
      }

      h3 {
         font-weight: 500;
         font-size: .8em;
         line-height: 1.4em;
         color: #000;
         margin: 0px 0px 12px 0px;
         padding: 3px 0px 9px 0px;
         text-transform: uppercase;
         border-bottom: 1px solid #ccc;
      }

      h4 {
         font-weight: 500;
         font-size: 0.8em;
         line-height: 1.4em;
         color: #000;
         margin: 0px;
         padding: 0px;
      }

      pre {
         float: left;
         display: block;
         width: 100%;
         overflow-y: hidden;
         overflow-x: auto;
         word-wrap: normal;
         font-size: 0.9em;
         font-family: 'SFMono-Regular', 'Menlo', 'Monaco', 'Consolas', 'Liberation Mono', 'Courier New', 'monospace';
         margin: 15px 0px;
         padding: 10px 20px;
         background: rgb(41, 45, 62);
         border-radius: 5px;
         color: rgb(191, 199, 213);;
      }

      img {
         max-width: 100%;
         margin: 15px 0px;
      }

      hr {
         border: none;
         border-top: 1px solid #ddd;
      }

      table {
         width: 100%;
         margin-bottom: 1em;
         border-top: 5px solid #ddd !important;
      }

      th {
         font-size: 0.9em;
         padding: 9px 12px;
         border: 1px solid #ddd;
         font-weight: bold;
         background-color: #eee !important;
      }

      td {
         font-size: 0.9em;
         padding: 12px;
         border: 1px solid #ddd;
      }

      ol, ul {
         margin: 0px;
         padding: 0px;

         li {
            margin-left: 24px;
         }

         ol, ul {
            margin: 0px;
            padding: 0px;

            li {
               padding: 0px;
            }
         }
      }

      iframe {
         width: 100%;
         height: 350px;
      }
   `
}
